export default "__VITE_ASSET__BRF0_OHV__"